import firebase from "firebase";
export const getEmailTemplate = async url => {
  let callable = firebase.functions().httpsCallable("getEmailTemplate");
  return callable({ url }).then(result => result.data);
};
export const scheduleEmailCampaign = async campaignId => {
  let callable = firebase.functions().httpsCallable("scheduleEmailCampaign");
  return callable(campaignId).then(result => result.data);
};
export const sendCampaignTest = async data => {
  let callable = firebase.functions().httpsCallable("sendCampaignTest");
  return callable(data).then(result => result.data);
};
export const sendEmailCampaignNow = async campaignId => {
  let callable = firebase.functions().httpsCallable("sendEmailCampaignNow");
  return callable(campaignId).then(result => result.data);
};
